import axios from "axios";

const instance = axios.create({
  baseURL: window.env?.BACKEND_ENDPOINT || "http://localhost:9090/api",
});

export default instance;
